import { PolicySeverity } from "@flexidao/dto";

export const formatPolicySeverity = (policySeverity: PolicySeverity): string => {
    switch (policySeverity) {
        case PolicySeverity.Low:
            return "Low";
        case PolicySeverity.Medium:
            return "Medium";
        case PolicySeverity.Critical:
            return "High";
    }
};
